<template>
  <div class="contact-box">
    <div class="item-contact">
      <template v-for="(item,index) in contactList">
        <contact-item v-model="contactList[index]" :key="index" :index="index"></contact-item>
        <div
          class="add-btn"
          :key="index+1"
          v-if="contactList.length === index+1 && item.name && item.mobile && item.email"
        >
          <van-button type="primary" icon="plus" @click="newContact">添加联系人</van-button>
        </div>
      </template>
      <van-button class="nextBtn" type="primary" size="large" @click="check">下一步</van-button>
    </div>
  </div>
</template>

<script>
import { Button, Toast } from "vant";
import { contactSave } from "@/api/login";
import contactItem from "@/components/contactItem";

export default {
  data() {
    return {
      contactList: [
        {
          name: "",
          mobile: "",
          email: "",
          telephone: "",
          company: "",
          fullAddress: ""
        }
      ]
    };
  },
  props: {
    member: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    [Button.name]: Button,
    contactItem
  },
  methods: {
    check() {
      let mobileList = this.contactList.map(item => item.mobile).sort(),
        emailList = this.contactList.map(item => item.email).sort();

      for (var i = 0; i < mobileList.length; i++) {
        if (mobileList[i] === mobileList[i + 1] && mobileList.length > 1) {
          Toast(`联系人不能拥有相同的手机号！`);
          return;
          break;
        }
      }

      for (var i = 0; i < emailList.length; i++) {
        if (emailList[i] === emailList[i + 1] && emailList.length > 1) {
          Toast(`联系人不能拥有相同的邮箱！`);
          return;
          break;
        }
      }

      for (let i = 0; i < this.contactList.length; i++) {
        if (!this.contactList[i].name) {
          Toast(`请输入联系人${i + 1}的姓名`);
          break;
        }

        if (!this.$regexp.mobile(this.contactList[i].mobile)) {
          Toast(`请输入联系人${i + 1}正确的手机号码`);
          break;
        }

        if (!this.$regexp.email(this.contactList[i].email)) {
          Toast(`请输入联系人${i + 1}正确的邮箱地址`);
          break;
        }

        if (i == this.contactList.length - 1) {
          this.next();
        }
      }
    },
    next() {
      if (!this.member.id) {
        return;
      }
      contactSave({
        memberId: this.member.id,
        contacts: JSON.stringify(this.contactList)
      })
        .then(res => {
          if (res.success) {
            this.$emit("sendActive", 3);
          } else {
            Toast(res.message || "联系人添加失败");
          }
        })
        .finally(() => {
          Toast("联系人添加失败");
        });
    },
    newContact() {
      this.contactList.push({
        name: "",
        mobile: "",
        email: "",
        telephone: "",
        company: "",
        fullAddress: ""
      });
    }
  }
};
</script>

<style lang="less" scoped>
.add-btn {
  margin-top: 10px;
  text-align: center;
}
.item-contact {
  margin-top: 10px;
}
.nextBtn {
  margin-top: 30px;
}
</style>
